import './PanelLayout.css';
import React, { useState } from 'react';
import PanelNavbar from '../PanelNavbar/PanelNavbar';
import PanelSlideMenu from '../PanelSlideMenu/PanelSlideMenu';
import { HiHomeModernIcon, HiTemplateIcon, HiUserGroupIcon, IconMessage, IconPaymentRequest } from '../../../components/Icon';

function PanelLayout(props) {

    const [isToggle, setIsToggle] = useState(false);
    const [isHover, setIsHover] = useState(false);

    const handleClick =()=>{
        setIsToggle((prev) => !prev)
    }

    const handleNotHover =(index)=>{
        setIsHover(false)
    }

    const handleLogout = (e) => {
        e.preventDefault()
        // if(window.confirm('Are you sure you want to log out') == true){
        //     dispatch(getLogout('/login'))
        //         .then((resp) => {
        //             navigate('/login')
        //         })
        //         .catch((err) => {
        //             window.alert(err.message)
        //             console.log(err)
        //         })
        // }
        
    }

    return (
        <div className='panelLayoutSection flex'>
            <div className='panelLayoutSlideMenu flex'
                style={{
                    maxWidth: !isToggle ? '5em' :'15em',
                    width: '100%',
                    position: 'fixed',
                    background: 'white',
                }}
            >
                <PanelSlideMenu 
                    menus={[
                        {   
                            href: '/executive/taxfile', 
                            name: 'Dashboard', 
                            icon: <HiHomeModernIcon />,
                            isHover: isHover,
                            // onMouseEnter:handleHover,
                            onMouseLeave:handleNotHover
                        },
                        {
                            href: '/executive/nrc-payment-requests', 
                            name: 'Templets', 
                            icon: <IconPaymentRequest />,
                            isHover: isHover,
                            // onMouseEnter:handleHover,
                            onMouseLeave:handleNotHover
                        },
                        {
                            href: '/executive/template/list', 
                            name: 'Templets', 
                            icon: <HiTemplateIcon />,
                            isHover: isHover,
                            // onMouseEnter:handleHover,
                            onMouseLeave:handleNotHover
                        },
                        {
                            href: '/executive/list', 
                            name: 'Executive', 
                            icon: <HiUserGroupIcon />,
                            isHover: isHover,
                            // onMouseEnter:handleHover,
                            onMouseLeave:handleNotHover
                        },
                        {
                            href: '/executive/messages',  
                            name: 'Messages', 
                            icon: <IconMessage />,
                            isHover: isHover,
                            // onMouseEnter:handleHover,
                            onMouseLeave:handleNotHover
                        },
                        // {
                        //     href: '/executive/chatfloor',  
                        //     name: 'Chatfloor', 
                        //     icon: <IconMessage />,
                        //     isHover: isHover,
                        //     // onMouseEnter:handleHover,
                        //     onMouseLeave:handleNotHover
                        // },
                    ]}

                    isToggle={isToggle}
                    
                    
                />
                
            </div>
            <div className=''
                    style={{
                        width: !isToggle ? '5em': '17.6em'
                    }}
                ></div>
            <div className='panelLayoutNavbar w-100'>
                <PanelNavbar 
                    isToggle={isToggle}
                    onClick={handleClick}
                    headerLeft={!isToggle ? '5em' : '15.3em'}
                    headerWidth={!isToggle ? 'cal(100% - 5em)' : 'cal(100% - 15.3em)'}
                />
                <div className=''
                style={{
                    height: '3.55em',
                }}
                >

                </div>
                <div className='panelLayoutContent w-'>
                    {props.children}
                    {/* <Outlet /> */}
                    
                </div>
            </div>
            
            
        </div>
    );
}


export default PanelLayout